import { render, staticRenderFns } from "./Assinatura.vue?vue&type=template&id=7bd8babe"
import script from "./Assinatura.vue?vue&type=script&lang=js"
export * from "./Assinatura.vue?vue&type=script&lang=js"
import style0 from "./Assinatura.vue?vue&type=style&index=0&id=7bd8babe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports